import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { StudentHatBlue } from "@similarweb/icons/illustrations";
import { PromoBanner } from "@similarweb/ui-components";

import signalRecommenderI18nKeys from "app/pages/sales-intelligence/modules/signal-recommender/utils/i18n";

const ILLUSTRATION_SIZE = 80;

export const SignalRecommenderBanner = (): ReactElement => {
    const { translate } = useTranslate();

    // PromoBanner forwards only className/children/ref, so the automation hook goes on a wrapper.
    // Harmless here: the banner carries no interaction to intercept.
    return (
        <div data-automation="signal-recommender-banner">
            <PromoBanner>
                <StudentHatBlue size={ILLUSTRATION_SIZE} />
                <PromoBanner.Content>
                    <PromoBanner.Title>{translate(signalRecommenderI18nKeys.banner.title)}</PromoBanner.Title>
                    <PromoBanner.Description>
                        {translate(signalRecommenderI18nKeys.banner.description)}
                    </PromoBanner.Description>
                </PromoBanner.Content>
            </PromoBanner>
        </div>
    );
};
